import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState } from 'react';
import Head from 'next/head';
import { useSelector } from 'store';
import ImageSlider from 'components/common/ImageSlider';
import InfoSlider from 'components/common/InfoSlider';
import Modal from 'components/common/Modal';
import styled from 'styled-components';
import ModalMapPopup from './components/ModalMapPopup';

var PlaceDetailService = function PlaceDetailService() {
  var branch = useSelector(function (state) {
    return state.space.branch;
  });
  var floors = branch.floors;
  var features = branch.features;

  var _useState = useState(false),
      isHoverOnMapIcon = _useState[0],
      setIsHoverOnMap = _useState[1];

  var kakao = branch.map_url_kakao;
  var google = branch.map_url_google;
  var naver = branch.map_url_naver;

  var _Modal = Modal(),
      openModal = _Modal.openModal,
      closeModal = _Modal.closeModal,
      ModalPortal = _Modal.ModalPortal;

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Head, {
      children: [/*#__PURE__*/_jsx("title", {
        children: "\uB85C\uCEEC\uC2A4\uD2F0\uCE58 - ".concat(branch.name)
      }), /*#__PURE__*/_jsx("meta", {
        name: "application-name",
        content: "\uB85C\uCEEC\uC2A4\uD2F0\uCE58 - ".concat(branch.name)
      }), /*#__PURE__*/_jsx("meta", {
        name: "msapplication-tooltip",
        content: "\uB85C\uCEEC\uC2A4\uD2F0\uCE58 - ".concat(branch.name)
      }), /*#__PURE__*/_jsx("meta", {
        id: "meta_og_title",
        property: "og:title",
        content: "\uB85C\uCEEC\uC2A4\uD2F0\uCE58 - ".concat(branch.name)
      }), branch.name === '을지로' && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("script", {
          children: "!function(f,b,e,v,n,t,s)\n          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?\n            n.callMethod.apply(n,arguments):n.queue.push(arguments)};\n            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';\n            n.queue=[];t=b.createElement(e);t.async=!0;\n            t.src=v;s=b.getElementsByTagName(e)[0];\n            s.parentNode.insertBefore(t,s)}(window, document,'script',\n          'https://connect.facebook.net/en_US/fbevents.js');\n          fbq('init', '1058468068326629');\n          fbq('track', 'PageView');"
        }), /*#__PURE__*/_jsx("noscript", {
          children: /*#__PURE__*/_jsx("img", {
            alt: " ",
            height: "1",
            width: "1",
            style: {
              display: 'none'
            },
            src: "https://www.facebook.com/tr?id=1058468068326629&ev=PageView&noscript=1"
          })
        })]
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "s-menu",
      children: /*#__PURE__*/_jsx("ul", {
        children: /*#__PURE__*/_jsx("li", {
          className: "selected",
          children: /*#__PURE__*/_jsx("a", {
            style: {
              cursor: 'default'
            },
            children: branch.region.name
          })
        })
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "cnts-wrap",
      children: /*#__PURE__*/_jsxs("div", {
        className: "retail-detail branch-type",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "hgroup",
          children: [/*#__PURE__*/_jsx("img", {
            src: branch.representation_image,
            className: "img",
            alt: ""
          }), /*#__PURE__*/_jsx("h2", {
            children: branch.name
          }), /*#__PURE__*/_jsx("address", {
            children: branch.address
          }), /*#__PURE__*/_jsxs("div", {
            className: "btn-map",
            style: {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            },
            children: [/*#__PURE__*/_jsxs(OpenMapModalButton, {
              onClick: openModal,
              onPointerEnter: function onPointerEnter() {
                return setIsHoverOnMap(true);
              },
              onPointerLeave: function onPointerLeave() {
                return setIsHoverOnMap(false);
              },
              children: [/*#__PURE__*/_jsx("img", {
                src: isHoverOnMapIcon ? '/images/map-gray.svg' : '/images/map.svg',
                alt: "",
                style: {
                  width: 28,
                  height: 28
                }
              }), /*#__PURE__*/_jsx("span", {
                style: {
                  color: isHoverOnMapIcon ? '#808080' : '#111',
                  marginLeft: 8
                },
                children: "\uC9C0\uB3C4 \uBCF4\uAE30"
              })]
            }), /*#__PURE__*/_jsxs("div", {
              children: [/*#__PURE__*/_jsx("span", {
                children: /*#__PURE__*/_jsx(OpenMapPageAnchor, {
                  href: kakao,
                  target: "_blank",
                  rel: "noreferrer",
                  children: "\uCE74\uCE74\uC624"
                })
              }), /*#__PURE__*/_jsx("span", {
                style: {
                  margin: 6
                },
                children: "\xB7"
              }), /*#__PURE__*/_jsx("span", {
                children: /*#__PURE__*/_jsx(OpenMapPageAnchor, {
                  href: google,
                  target: "_blank",
                  rel: "noreferrer",
                  children: "\uAD6C\uAE00"
                })
              }), /*#__PURE__*/_jsx("span", {
                style: {
                  margin: 6
                },
                children: "\xB7"
              }), /*#__PURE__*/_jsx("span", {
                children: /*#__PURE__*/_jsx(OpenMapPageAnchor, {
                  href: naver,
                  target: "_blank",
                  rel: "noreferrer",
                  children: "\uB124\uC774\uBC84"
                })
              })]
            })]
          }), branch.button_text && /*#__PURE__*/_jsx("a", {
            href: branch.button_url,
            style: {
              display: 'block',
              border: '2px solid #111',
              padding: 12,
              margin: '20px auto 0 auto',
              width: '70%',
              fontWeight: 'bold'
            },
            target: "_blank",
            rel: "noopener noreferrer",
            children: branch.button_text
          })]
        }), /*#__PURE__*/_jsx(ImageSlider, {
          images: branch.images
        }), /*#__PURE__*/_jsx("div", {
          className: "detail-cnts",
          children: /*#__PURE__*/_jsx("p", {
            style: {
              whiteSpace: 'pre-line'
            },
            children: branch.introduction
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: "retail-info",
          children: [/*#__PURE__*/_jsxs("h3", {
            children: [branch.name, " \uD2B9\uC9D5"]
          }), /*#__PURE__*/_jsx("ul", {
            children: features.map(function (feature, index) {
              return /*#__PURE__*/_jsx("li", {
                children: feature.text
              }, index);
            })
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "space-guide",
          children: [/*#__PURE__*/_jsx("h3", {
            children: "\uCE35\uBCC4 \uC548\uB0B4"
          }), /*#__PURE__*/_jsx(InfoSlider, {
            floors: floors
          })]
        }), branch.button_text && /*#__PURE__*/_jsx("a", {
          href: branch.button_url,
          style: {
            display: 'block',
            border: '2px solid #111',
            padding: 16,
            margin: '20px auto 0 auto',
            fontWeight: 'bold',
            textAlign: 'center'
          },
          target: "_blank",
          rel: "noopener noreferrer",
          children: branch.button_text
        })]
      })
    }), /*#__PURE__*/_jsx(ModalPortal, {
      children: /*#__PURE__*/_jsx(ModalMapPopup, {
        closeModal: closeModal,
        branch: branch
      })
    })]
  });
};

var OpenMapModalButton = styled.div.withConfig({
  displayName: "_place_detail__OpenMapModalButton",
  componentId: "sc-jjm0ne-0"
})(["display:flex;align-items:center;justify-content:center;cursor:pointer;margin-right:8px;padding-right:8px;border-right:1px solid #111;"]);
var OpenMapPageAnchor = styled.a.withConfig({
  displayName: "_place_detail__OpenMapPageAnchor",
  componentId: "sc-jjm0ne-1"
})([":hover{color:#808080;}"]);
export default PlaceDetailService;